import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Observable } from 'rxjs';

import { PortfolioSimulationParameters } from '@core/models/portfolio-simulation.model';

import { PortfolioSimulationState, PortfolioSimulationStore } from './portfolio-simulation.store';

@Injectable({ providedIn: 'root' })
export class PortfolioSimulationQuery extends QueryEntity<PortfolioSimulationState> {
  constructor(protected store: PortfolioSimulationStore) {
    super(store);
  }

  selectParameters$(): Observable<PortfolioSimulationParameters | null> {
    return this.select(state => state.parameters);
  }

  selectLoading$(): Observable<boolean> {
    return this.select(state => state.loading);
  }

  selectError$(): Observable<string | null> {
    return this.select((state) => state.error);
  }

  getParameters(): PortfolioSimulationParameters | null {
    return this.getValue().parameters;
  }
}
